// DS4.4
import React from 'react';
import c from 'classnames';
import InputHint from '../../InputHint';
import InputLabelSubText from '../../InputLabelSubText';
import InputLabelText from '../../InputLabelText';
import InputErrorMessage from '../../InputErrorMessage';
import InputSuccessMessage from '../../InputSuccessMessage';
import FormElement from '../../layouts/FormElement';
import Checkbox from '../../../Checkbox';
import MainToggle from '../MainToggle';
import s from './BooleanInput.scss';
/**
 * A boolean field, either in toggle or checkbox format.
 */
var BooleanInput = function (_a) {
    var id = _a.id, name = _a.name, label = _a.label, subLabel = _a.subLabel, details = _a.details, className = _a.className, validationResult = _a.validationResult, noBottomSpacing = _a.noBottomSpacing, biData = _a.biData, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.value, value = _c === void 0 ? false : _c, _d = _a.size, size = _d === void 0 ? 'small' : _d, _e = _a.type, type = _e === void 0 ? 'checkbox' : _e, onChange = _a.onChange;
    var wrappedDetails = null;
    var errorMessageId = id + "-error";
    var hintId = id + "-hint";
    var onLabelClick = function (ev) {
        // If a link inside the label was clicked, avoid changing the checkbox value
        var target = ev.target;
        if (target.tagName.toLowerCase() === 'a') {
            ev.stopPropagation();
            return;
        }
        if (!disabled) {
            onChange(!value);
        }
    };
    switch (validationResult) {
        case 'success':
            wrappedDetails = React.createElement(InputSuccessMessage, null, details);
            break;
        case 'error':
            wrappedDetails = (React.createElement(InputErrorMessage, { id: errorMessageId }, details));
            break;
        default:
            wrappedDetails = details && React.createElement(InputHint, { id: hintId }, details);
    }
    return (React.createElement(FormElement, { className: c(className, s["size-" + size], disabled && s['disabled']), inputId: id, label: label, isLabelHidden: true, subLabel: subLabel && React.createElement(InputLabelSubText, null, subLabel), details: wrappedDetails, noBottomSpacing: noBottomSpacing },
        React.createElement("div", { className: s['wrapper'] },
            type === 'checkbox' && (React.createElement(Checkbox, { ariaLabelledBy: id + "-label", isChecked: value, onChange: onChange, disabled: disabled, name: name, biData: biData })),
            type === 'toggle' && (React.createElement(MainToggle, { "aria-labelledby": id + "-label", size: 'small', onChange: onChange, value: value, disabled: disabled, biData: biData })),
            React.createElement(InputLabelText, { className: s['label-text'], onClick: onLabelClick }, label))));
};
BooleanInput.displayName = 'BooleanInput';
export default BooleanInput;
//# sourceMappingURL=BooleanInput.js.map